import { IMember, IMemberBasicProfile } from "constants/merchants";
import _ from "lodash/fp";
import { combineReducers } from "redux";
import { handleActions } from "redux-actions";
import { MERCHANT_ADMIN_MEMBER_DETAILS } from "../constants/action-types";
import { progressActions } from "./base-reducers";

interface IBaseState<T> {
    payload: T;
    error?: { message: string };
}

export interface IMerchantAdminMemberDetailsState {
    member: IMemberState;
    memberAttributes: IMemberAttributesState;
    successMessage: string;
    errorMessage: string;
}

interface IMemberState extends IBaseState<IMember> {
    isFetching: boolean;
}
interface IMemberAttributesState extends IBaseState<IMemberBasicProfile> {
    isFetching: boolean;
}

export const merchantAdminMemberDetails = combineReducers<IMerchantAdminMemberDetailsState>({
    member: handleActions(
        {
            ...progressActions(MERCHANT_ADMIN_MEMBER_DETAILS.MEMBER.FETCH, "isFetching"),
            [MERCHANT_ADMIN_MEMBER_DETAILS.MEMBER.DEACTIVATE.SUCCESS]: (state: IMemberState) =>
                _.set(["payload", "not_deactivated"])(false)(state),
            [MERCHANT_ADMIN_MEMBER_DETAILS.MEMBER.ACTIVATE.SUCCESS]: (state: IMemberState) =>
                _.set(["payload", "not_deactivated"])(true)(state),
        } as any,
        {
            payload: null,
            isFetching: false,
            error: null,
        },
    ),
    memberAttributes: handleActions(
        {
            ...progressActions(MERCHANT_ADMIN_MEMBER_DETAILS.MEMBER_BASIC_PROFILE.FETCH, "isFetching"),
        } as any,
        {
            payload: null,
            isFetching: false,
            error: null,
        },
    ),
});
